import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { logger, loggerOptions } from '@/plugins/logging-plugin';
import axiosSetup from '@/middleware/axios-request-interceptor';
import { configureVuetify } from '@/plugins/vuetifyConf';
import kc from '@/plugins/keycloak-plugin';
import meteringPointMembershipService from '@/services/meteringPointMembershipService';
import accountService from '@/services/accountService';
import billrunsDataFetchingService from '@/services/billrunsDataFetchingService';
import { markRaw } from 'vue';
import { ALL_DATA_SERVICE, WORKER_CLIENT } from '@/plugins/dependencySymbols';
import { fetchAllData, allMetaDataLoaded } from '@/services/allDataService';

export default function registerDependencies(app) {
  // Logging
  app.use(logger, loggerOptions);

  // HTTP middleware
  axiosSetup(app);

  // State management
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  pinia.use(({ store }) => {
    store.$log = markRaw(app.config.globalProperties.$log);
  });
  app.use(pinia);

  // UI
  configureVuetify(app);

  // Auth
  app.use(kc);

  // Business services
  app.use(meteringPointMembershipService);
  app.use(accountService);
  app.use(billrunsDataFetchingService);

  // Global provides
  app.provide('log', markRaw(app.$log));
  app.provide('logger', markRaw(app.$log));
  app.config.globalProperties.$app = app;
  app.provide('$app', app);

  // Dependency symbols
  app.provide(ALL_DATA_SERVICE, { fetchAllData, allMetaDataLoaded });
  app.provide(WORKER_CLIENT, null);
}


